
import { Product } from "@/types/product";

export const FEATURED_PRODUCTS: Product[] = [
  // Pain Management
  {
    id: "paracetamol-extra",
    title: "Paracetamol Extra Strength",
    price: 2500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/paracetamol_xpbhd4.jpg",
    prescription: false,
    category: "Pain Relief",
    frequentlyBought: true,
  },
  {
    id: "diclofenac-gel",
    title: "Diclofenac Gel",
    price: 3200,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/diclofenac_gel_nstqxw.jpg",
    prescription: false,
    category: "Pain Relief",
  },
  {
    id: "ibuprofen-400",
    title: "Ibuprofen 400mg",
    price: 1800,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472546/pharmacy-lovable/ibuprofen_400mg_jepfgo.jpg",
    prescription: false,
    category: "Pain Relief",
  },
  // Antibiotics
  {
    id: "amoxicillin",
    title: "Amoxicillin 500mg",
    price: 4500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/amoxicillin_qkswvg.jpg",
    prescription: true,
    category: "Antibiotics",
    frequentlyBought: true,
  },
  {
    id: "azithromycin",
    title: "Azithromycin",
    price: 6800,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/azithromycin_kkqczj.jpg",
    prescription: true,
    category: "Antibiotics",
  },
  // Diabetes Care
  {
    id: "metformin",
    title: "Metformin 1000mg",
    price: 3900,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/metformin_vhqxis.jpg",
    prescription: true,
    category: "Diabetes",
  },
  {
    id: "test-strips",
    title: "Blood Sugar Test Strips",
    price: 5200,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/test_strips_uxxeap.jpg",
    prescription: false,
    category: "Diabetes",
    frequentlyBought: true,
  },
  // Heart Health
  {
    id: "amlodipine",
    title: "Amlodipine 5mg",
    price: 2800,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/amlodipine_d7bkvx.jpg",
    prescription: true,
    category: "Heart Health",
  },
  {
    id: "aspirin",
    title: "Aspirin 75mg",
    price: 1500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/aspirin_wvrozu.jpg",
    prescription: false,
    category: "Heart Health",
    frequentlyBought: true,
  },
  // Vitamins & Supplements
  {
    id: "vitamin-d3",
    title: "Vitamin D3 Supplements",
    price: 4200,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/vitamin_d3_kxwcey.jpg",
    prescription: false,
    category: "Vitamins",
  },
  {
    id: "omega-3",
    title: "Omega-3 Fish Oil",
    price: 7500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/omega3_rup8te.jpg",
    prescription: false,
    category: "Vitamins",
    frequentlyBought: true,
  },
  {
    id: "multivitamin-gummies",
    title: "Multivitamin Gummies",
    price: 5500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472546/pharmacy-lovable/multivitamin_gummies_zzt4vr.jpg",
    prescription: false,
    category: "Vitamins",
  },
  {
    id: "calcium-tablets",
    title: "Calcium + Vitamin D Tablets",
    price: 3400,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/calcium_tablets_e3kewx.jpg",
    prescription: false,
    category: "Vitamins",
  },
  // Respiratory Care
  {
    id: "ventolin",
    title: "Ventolin Inhaler",
    price: 3800,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/ventolin_inhaler_qcwkuf.jpg",
    prescription: true,
    category: "Respiratory",
  },
  {
    id: "antihistamine",
    title: "Antihistamine Tablets",
    price: 2900,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1706398543/pharmacy/antihistamine_tablets_wbzxpq.jpg",
    prescription: false,
    category: "Respiratory",
    frequentlyBought: true,
  },
  {
    id: "cetirizine-tablets",
    title: "Cetirizine Allergy Tablets",
    price: 2500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/cetirizine_tablets_sfrltj.jpg",
    prescription: false,
    category: "Respiratory",
  },
  // Skincare
  {
    id: "acne-cream",
    title: "Acne Treatment Cream",
    price: 4800,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/acne_cream_gkbjmj.jpg",
    prescription: false,
    category: "Skincare",
  },
  {
    id: "hydrating-cleanser",
    title: "Hydrating Facial Cleanser",
    price: 5200,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/hydrating_cleanser_v3lq8y.jpg",
    prescription: false,
    category: "Skincare",
    frequentlyBought: true,
  },
  // First Aid
  {
    id: "antiseptic-wipes",
    title: "Antiseptic Wipes (50 count)",
    price: 2200,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/antiseptic_wipes_vsdexg.jpg",
    prescription: false,
    category: "First Aid",
  },
  {
    id: "band-aids",
    title: "Waterproof Band-Aids (100 count)",
    price: 1900,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/band_aids_doh9qt.jpg",
    prescription: false,
    category: "First Aid",
  },
  // Digestive Health
  {
    id: "probiotic-supplements",
    title: "Probiotic Supplements",
    price: 8500,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472546/pharmacy-lovable/probiotic_supplements_d3fswx.jpg",
    prescription: false,
    category: "Digestive Health",
  },
  {
    id: "indigestion-relief",
    title: "Indigestion Relief Tablets",
    price: 3100,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/indigestion_relief_u25yif.jpg",
    prescription: false,
    category: "Digestive Health",
  },
  // Eye Care
  {
    id: "eye-drops",
    title: "Lubricating Eye Drops",
    price: 2600,
    image: "https://res.cloudinary.com/dqrk9qbgn/image/upload/v1718472545/pharmacy-lovable/eye_drops_aajcfb.jpg",
    prescription: false,
    category: "Eye Care",
  }
];
